import { render, staticRenderFns } from "./AplicarMargenComercialModal.vue?vue&type=template&id=736e3416"
import script from "./AplicarMargenComercialModal.vue?vue&type=script&lang=js"
export * from "./AplicarMargenComercialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports